import React from "react";
import "./StyleCrewPage.css";

const StyleCrewPara = () => {
  return (
    <div className="styleCrewParaContainer">
      <p>
        At the heart of scent, culture is experienced, specialized
        professionalism – a service beyond the expectations of our discerning,
        fastidious guest.
      </p>
      <p>
        Gifted professionals make team scent. Flair for the craft makes the team
        extraordinary. Creative freedom and unique styling skills define our
        personnel.
      </p>
      <p>
        Scent boasts of distinctive cosmopolitan clientele who expects
        exclusivity. Team scent does just that -YOU to relax and indulge while
        the artisans pamper and please you with personalized and bespoke service
        that speaks volume for itself.
      </p>
    </div>
  );
};

export default StyleCrewPara;
